<template>
  <v-form
    ref="itemsform"
    lazy-validation
  >
    <v-text-field
      v-model="editedItem.sql_load_balancer_ip"
      label="SQL LB ip/url"
      outlined
      :rules="[rules.required]"
    />
    <v-select
      v-model="editedItem.region_id"
      :items="regions"
      item-text="region_short"
      item-value="region_id"
      label="Region"
    />
    <v-select
      v-model="editedItem.primary_server_id"
      :items="sqlServers"
      item-text="sql_server_name"
      item-value="sql_server_id"
      label="Primary SQL Server"
    />
    <v-select
      v-model="editedItem.secondary_server_id"
      :items="sqlServers"
      item-text="sql_server_name"
      item-value="sql_server_id"
      label="Secondary SQL Server"
    />
    <v-text-field
      v-model="editedItem.availability_group"
      label="Availability Group"
      outlined
    />
    <v-switch
      v-model="editedItem.customer_ag"
      label="Customer AG"
      true-value="y"
      false-value="n"
    />
  </v-form>
</template>
<script>
  export default {
    name: 'sqllbForm',
    props: {
      editedItem: Object,
      regions: Array,
      sqlServers: Array
    },
    data () {
      return {
        rules: {
          required: value => !!value || 'Required.',
        },
      }
    },
  }
</script>